import * as React from "react";
import Header from "../Header";
import Footer from "../Footer";
import {IOpeningHours, IOpeningHoursWeakly} from "../../interfaces/IRestaurant";
import {IDelivery} from "../../interfaces/IDelivery";
import {Api} from "../../lib/Api";
import OpeningHours from "../global/OpeningHours";
import HolidayBox from "./restaurant/HolidayBox";
import LoaderComp from "../../../avernus/loader/source/LoaderComp";

interface IRestaurantOpeningHoursProps {
    setUrl: any
    id    : number
}

interface IForm {
    id          : number
    opening_hours   : any
}
interface IFormSaveData extends IOpeningHours, IOpeningHoursWeakly{
    id                                       : number
}

interface IRestaurantOpeningHoursState {
    success             : string
    error               : string
    form                : IForm
    loading             : boolean
    changedForm         : boolean
}

interface ISaveForm{
    id      ?: number
    success : string
    error   : string
}

interface IInitResult{
    deliveryOptions      : Array<IDelivery>
}

interface IgetResult{
    item    :IFormSaveData
    error   :string
}

export default class RestaurantOpeningHours extends React.Component<IRestaurantOpeningHoursProps, IRestaurantOpeningHoursState>{

    private originalData:IOpeningHours;

  	constructor(props:IRestaurantOpeningHoursProps){
        super(props);
        this.state = {
            success                 : null,
            error                   : null,
            form                    : this.props.id === 0?this.createEmptyForm(): null,
            loading                 : this.props.id>0,
            changedForm             : false
        };
        this.init();
    }

    createEmptyForm(): IForm {
        return {
            id : 0,
            opening_hours: []
       };
    }

    private init(){
        Api.call('/restaurant/get', { id: this.props.id}, (result:IgetResult) =>{
            console.log(this.props.id);
            console.log(result);
            if ( result.item === null ) {
                this.setState({
                    error                  : result.error,
                    loading                : false,
                });
            }else{
                let form:IForm                          = result.item as any;

                console.log(form);

                this.setState({
                    form                   : form,
                    loading                : false,
                    error                  : null
                });
            }
        } );
    }

    private submitHandler(evt): void {
        if ( evt !== undefined ) {
            evt.preventDefault();
        }
        let saveData:IFormSaveData            = this.state.form as any;
        console.log(saveData);
        Api.call('/restaurant/updateOpeningHours', saveData, (result:ISaveForm)=>{
            this.setState({
                success:    result.success,
                error:      result.error,
            }, () =>{
            });
        });
    }

    private getWeekNumberClickHandler(evt): void {
        evt.preventDefault();
        let form = this.state.form;

        this.setState({
            form: form
        }, () =>{
            this.submitHandler(undefined);
        });
    }





    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        var form    = this.state.form;
        form[type]  = evt.target.value;
        this.setState({
            form       : form
        });
    }



    render() {
        return (
            <div id="restaurant_openinghours">
               <Header title="Working hours" setUrl={this.props.setUrl}/>

               <div className="content_section container">
                   <div className = "h1_box">
                       <h1>Opening hours</h1>
                   </div>
                    <section className="opening_hours">
                        { (this.state.loading === true || this.state.form === null)?<div>
                            { this.state.error !== null?<div className="alert alert-danger">
                                        { this.state.error }
                            </div>:<LoaderComp show={true} />}
                        </div>:<>
                            <form onSubmit={ e => this.submitHandler(e) }>
                                <OpeningHours
                                    key={'opening_hours_'+this.props.id}
                                    hideTitleRow={true}
                                    openingHours = {this.state.form.opening_hours}

                                    changed={ (ret) => {
                                        let form  = this.state.form;
                                        form.opening_hours = ret;

                                        this.setState({
                                            form        : form,
                                            changedForm : true
                                        });
                                    } }
                                />


                                 {this.buttonBar()}
                            </form>
                        </> }

                        <h2 className="text-center">Holidays</h2>
                        <HolidayBox
                            key={this.props.id}
                            id={this.props.id}
                            xhrGetItems={"/restaurant/getConnectedRestaurantExceptionDate"}
                            xhrAdd={"/restaurant/addRestaurantExceptionDate"}
                            xhrRemove={"/restaurant/removeRestaurantExceptionDate"}
                        />
                    </section>
               </div>

               <Footer setUrl={this.props.setUrl}/>
            </div>
        );
    }

    private buttonBar(){
        return  <div className="form-row" style={{
                    marginTop: '15px'
                }}>
                <div className="col-sm-12">
                    { this.state.error !== null?<div className="alert alert-danger">
                            { this.state.error }
                    </div>:''}
                    { this.state.success !== null?<div className="alert alert-success">
                            { this.state.success }
                    </div>:''
                    }
                </div>
                <div className="col">
                    <button className="purple_btn" id="opening_hours_save_btn" type="submit">Save</button>
                </div>

            </div>
    }
}
